// extracted by mini-css-extract-plugin
export var legendIndicator = "_d9-1";
export var legendRight = "_d9-0";